import React from 'react';
import PropTypes from 'prop-types';
import Column from '../../Column';
import getPreviewDataToImport from '../helpers/getPreviewDataToImport';
import StyledTable from '../styled/table';
export default function StepFour(props) {
  var schemaFields = props.schemaFields,
      data = props.data,
      fieldsMap = props.fieldsMap,
      attributes = props.attributes;
  var previewData = getPreviewDataToImport(data.slice(0, 5), fieldsMap, attributes);
  return React.createElement(StyledTable, {
    keyField: "id",
    data: previewData
  }, schemaFields.map(function (field, index) {
    var key = "column-".concat(index);
    return React.createElement(Column, {
      key: key,
      header: field,
      field: field
    });
  }));
}
StepFour.propTypes = {
  schemaFields: PropTypes.array,
  data: PropTypes.array,
  fieldsMap: PropTypes.object,
  attributes: PropTypes.object
};
StepFour.defaultProps = {
  schemaFields: [],
  data: [],
  fieldsMap: {},
  attributes: {}
};